import { useQuery } from "@apollo/client";
import { Dropdown, Spin } from "antd";
import { useState, useEffect, forwardRef } from "react";
import { EmptyIcon } from "@phosphor-icons/react";
import { get, isNil } from "lodash";
import Search from "shared/components/Input";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

const RenderContent = forwardRef(
  ({ searchFields, items, onSearch, handleSelect, Item, placeholder }, ref) => {
    const { t } = useTranslation(NAME_SPACES.COMPONENTS);
    const DROPDOWN = t("DROPDOWN", { returnObjects: true });
    const [search, setSearch] = useState("");
    const filterOptions = (options) => {
      if (!search) return options;
      return options.filter((opt) =>
        searchFields.some((field) => {
          const value = get(opt, field, "");
          return value && value.toLowerCase().includes(search.toLowerCase());
        })
      );
    };
    return (
      <div className="dropdown__wrapper">
        <Search
          className="dropdown__wrapper--search"
          placeholder={placeholder || DROPDOWN.SEARCH}
          size="small"
          type="search"
          onChange={(e) => {
            const _ = e.target.value;
            setSearch(_);
            return onSearch(_);
          }}
        />
        {items.length > 0 ? (
          filterOptions(items).map((item, i) => {
            return (
              <Item
                ref={ref}
                item={item}
                key={item.id}
                onClick={() => {
                  handleSelect(item);
                }}
              />
            );
          })
        ) : (
          <div className="dropdown__wrapper--no-data">
            <EmptyIcon size={20} />
            <span>{DROPDOWN.NO_DATA}</span>
          </div>
        )}
      </div>
    );
  }
);

const DropdownComponent = ({
  onChange = () => {},
  onSearch = () => {},
  onSelect = () => {},
  node = [],
  searchFields = ["label", "value"],
  placeholder = "",
  displays,
  ...rest
}) => {
  const [query, options, accessor] = node;
  const { data, loading } = useQuery(query, options);
  const items = get(data, accessor, []);
  const [item, setItem] = useState(null);
  const [open, setOpen] = useState(false);

  const handleSelect = (item) => {
    setItem(item);
    onSelect(item);
    setOpen(false);
  };

  useEffect(() => {
    if (loading === false && !isNil(items)) return setItem(items[0]);
  }, [items, loading]);

  if (loading)
    return (
      <div className="dropdown__wrapper--loading">
        <Spin size="small" />
      </div>
    );

  return (
    <div className="main__dropdown">
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        dropdownRender={() => (
          <RenderContent
            items={items}
            searchFields={searchFields}
            onSearch={onSearch}
            handleSelect={handleSelect}
            Item={displays.unselected}
            onChange={onChange}
            placeholder={placeholder}
          />
        )}
        trigger={["click"]}
        placement="bottomRight"
        {...rest}
      >
        <displays.selected item={item} />
      </Dropdown>
    </div>
  );
};

export default DropdownComponent;
